// React and related imports
import React from 'react';

// Flowbite components
import { Button } from 'flowbite-react';

// React Router
import { useNavigate } from 'react-router-dom';

// Unauthorized Error Svg
import Unauthorized401 from '../assets/images/401-error-unauthorized-animate.svg';

// i18n hooks
import { useTranslation } from 'react-i18next';

// Hooks
import { usePageTitle } from '../hooks/usePageTitle';

// Auth
import { useUserInfo } from '../auth/UserInfoProvider';
import { homePath } from '../auth/roleMatrix';

export const UnauthorizedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userInfo } = useUserInfo();

  usePageTitle(t('pageTitles.unauthorized'));

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-50 px-4 text-center dark:bg-gray-900">
      <h1 className="text-3xl font-extrabold leading-tight tracking-tight text-red-600 dark:text-red-400 md:text-4xl">
        {t('unauthorized.title')}
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-300">
        {t('unauthorized.body')}
      </p>
      {userInfo && (
        <Button
          color="gray"
          onClick={() => navigate(homePath(userInfo.role), { replace: true })}
        >
          {t('unauthorized.goHome')}
        </Button>
      )}
      <img
        src={Unauthorized401}
        alt=""
        aria-hidden="true"
        className="h-auto w-full max-w-lg"
      />
    </main>
  );
};
